/* Hide the floating chat bubble while the filter drawer is open.
 *
 * Shopify Inbox renders a <shopify-chat> element with a huge z-index that
 * floats above the drawer's Apply / Remove all row on phones. The drawer is
 * the native <details class="mobile-facets__disclosure"> in
 * snippets/facets.liquid; its `toggle` event does not bubble, so listen in
 * the capture phase on the document (survives AJAX re-renders too).
 * Mirrors sc-cart-drawer-mobile.js, which does the same for the cart drawer.
 */
(function () {
  'use strict';

  var SELECTORS = [
    'shopify-chat',
    '[class*="chat-button-container"]',
    'iframe[src*="shopify-inbox"]',
    'iframe[src*="shop.app/chat"]',
    // Elfsight chat widget (legacy, kept as a fallback)
    '.elfsight-app-1456b500-0ab1-4458-8d43-fa7e0c8875f8',
    '[class*="eapps-"]',
  ];
  var hidden = [];

  function hideChatWidget() {
    hidden = [];
    document.querySelectorAll(SELECTORS.join(',')).forEach(function (el) {
      hidden.push({
        el: el,
        display: el.style.getPropertyValue('display'),
        priority: el.style.getPropertyPriority('display'),
      });
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function restoreChatWidget() {
    hidden.forEach(function (entry) {
      if (entry.display) {
        entry.el.style.setProperty('display', entry.display, entry.priority);
      } else {
        entry.el.style.removeProperty('display');
      }
    });
    hidden = [];
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details.matches || !details.matches('details.mobile-facets__disclosure')) return;
      if (details.open) {
        hideChatWidget();
      } else {
        restoreChatWidget();
      }
    },
    true
  );
})();
